import React, { Component } from "react";
import PropTypes from "prop-types";
import IconButton from "material-ui/IconButton";
import ActionSave from "material-ui/svg-icons/content/save";
import { DivHeaderActions, DivTitle } from "./styled";
import Paper from "material-ui/Paper";
import { Card, CardHeader, CardText } from "material-ui/Card";
import { SketchColorPicker, UploadImage } from "../../../components";
import { RTInput, Counter, BlockCounter } from "./components";
import ActionCopy from "material-ui/svg-icons/content/content-copy";
import ActionPaste from "material-ui/svg-icons/content/content-paste";

const toolbar = [
  [{ font: [false, "serif", "monospace", "Ubuntu", "GreatVibes"] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ size: ["small", false, "large", "huge"] }],
  ["bold", "italic", "underline", "strike"],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ color: [] }, { background: [] }],
  [{ align: [] }],
  ["blockquote", "code-block"],
  ["clean"]
];

class ImageTextView extends Component {
  constructor(props) {
    super(props);
    const {
      containerPadding,
      backgroundColor,
      text,
      backgroundImage
    } = props.data.values;
    const lH = text.lineHeight.split("%").join("") * 1;
    const lS = text.letterSpacing.split("px").join("") * 1;
    this.state = {
      isEditMode: false,
      expanded: true,
      text: text,
      valueText: text.value,
      backgroundColorText: text.backgroundColor,
      containerPaddingText: text.containerPadding,
      backgroundImage: backgroundImage,
      backgroundColor: backgroundColor,
      containerPadding: containerPadding,
      lineHeight: lH,
      letterSpacing: lS
    };
  }
  handleExpandChange = expanded => {
    this.setState({ expanded: expanded });
  };
  onClickSave = () => {
    let newData = this.props.data;
    let text = this.state.text;
    text.value = this.state.valueText;
    text.lineHeight = this.state.lineHeight + "%";
    text.letterSpacing = this.state.letterSpacing + "px";
    text.backgroundColor = this.state.backgroundColorText;
    text.containerPadding = this.state.containerPaddingText;
    newData.values.containerPadding = this.state.containerPadding;
    newData.values.backgroundImage = this.state.backgroundImage;
    newData.values.text = text;
    this.props.onUpdateData(newData);
  };
  onChangeText = value => {
    this.setState({ valueText: value });
  };

  onUpdatePadding = padding => {
    this.setState({ containerPadding: padding });
  };

  onUpdatePaddingText = padding => {
    this.setState({ containerPaddingText: padding });
  };

  onUpdateBackgroundText = color => {
    this.setState({ backgroundColorText: color });
  };
  onUpdateUrl = value => {
    this.setState({ backgroundImage: value });
  };
  onUpdateLineHeight = value => {
    this.setState({ lineHeight: value });
  };
  onUpdateLetterSpacing = value => {
    this.setState({ letterSpacing: value });
  };
  onClickCopy = () => {
    let newData = this.props.data;
    let text = this.state.text;
    text.value = this.state.valueText;
    text.lineHeight = this.state.lineHeight + "%";
    text.letterSpacing = this.state.letterSpacing + "px";
    text.backgroundColor = this.state.backgroundColorText;
    text.containerPadding = this.state.containerPaddingText;
    newData.values.containerPadding = this.state.containerPadding;
    newData.values.backgroundImage = this.state.backgroundImage;
    newData.values.text = text;
    localStorage.setItem("ImageTextView", JSON.stringify(newData.values));
  };
  onClickPaste = () => {
    const imageTextContent = JSON.parse(localStorage.getItem("ImageTextView"));
    if (imageTextContent) {
      const {
        containerPadding,
        backgroundColor,
        text,
        backgroundImage
      } = imageTextContent;
      const lH = text.lineHeight.split("%").join("") * 1;
      const lS = text.letterSpacing.split("px").join("") * 1;
      this.setState({
        text: text,
        valueText: text.value,
        backgroundColorText: text.backgroundColor,
        containerPaddingText: text.containerPadding,
        backgroundImage: backgroundImage,
        backgroundColor: backgroundColor,
        containerPadding: containerPadding,
        lineHeight: lH,
        letterSpacing: lS
      });
    }
  };

  render() {
    const { type } = this.props.data.values;
    return (
      <div style={{ width: "100%" }}>
        <div style={styles.paperCard}>
          <Card
            expanded={this.state.expanded}
            onExpandChange={this.handleExpandChange}
          >
            <CardHeader
              title="General"
              subtitle="Content Image and Text"
              actAsExpander={true}
              showExpandableButton={true}
              style={styles.headerCard}
            />

            <CardText
              style={{ overflowY: "scroll", height: 500 }}
              expandable={true}
            >
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Setting Text</DivTitle>
                <div style={styles.divText}>
                  <RTInput
                    input={
                      <input
                        type="text"
                        name="name"
                        value={this.state.valueText}
                        onChange={value => this.onChangeText(value)}
                      />
                    }
                    source="body"
                    label="Body"
                    toolbar={toolbar}
                  />
                </div>
                <div style={styles.divText}>
                  <Counter
                    isDisabled={true}
                    title="Line Height"
                    onSetValue={value => this.onUpdateLineHeight(value)}
                    value={this.state.lineHeight}
                    interval={10}
                    subtitle="%"
                    minValue={100}
                  />
                </div>
                <div style={styles.divText}>
                  <Counter
                    isDisabled={false}
                    title="Letter Spacing"
                    onSetValue={value => this.onUpdateLetterSpacing(value)}
                    value={this.state.letterSpacing}
                    interval={1}
                    subtitle="px"
                    minValue={-5}
                  />
                </div>
                <div style={styles.divText}>
                  <DivTitle>Text Padding</DivTitle>
                  <BlockCounter
                    containerPadding={this.state.containerPaddingText}
                    onUpdatePadding={containerPadding =>
                      this.onUpdatePaddingText(containerPadding)
                    }
                  />
                </div>
                <div style={styles.divText}>
                  <SketchColorPicker
                    title={"Background Text"}
                    onUpdateColor={color => this.onUpdateBackgroundText(color)}
                    color={this.state.backgroundColorText}
                  />
                </div>
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Setting Container</DivTitle>
                <div>
                  <UploadImage
                    type={type}
                    imageUrl={this.state.backgroundImage}
                    onUpdateUrl={value => this.onUpdateUrl(value)}
                    title="Image"
                  />
                </div>
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Container Padding</DivTitle>
                <BlockCounter
                  containerPadding={this.state.containerPadding}
                  onUpdatePadding={containerPadding =>
                    this.onUpdatePadding(containerPadding)
                  }
                />
              </Paper>
            </CardText>
          </Card>
        </div>
        <DivHeaderActions>
          <IconButton
            onClick={this.onClickCopy}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionCopy />
          </IconButton>
          <IconButton
            onClick={this.onClickPaste}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionPaste />
          </IconButton>
          <IconButton
            onClick={this.onClickSave}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionSave />
          </IconButton>
        </DivHeaderActions>
      </div>
    );
  }
}

const styles = {
  paper: {
    margin: 10,
    padding: 10
  },
  headerCard: {
    display: "flex",
    textAlign: "left"
  },
  paperCard: {
    margin: 10
  },
  paperText: {
    padding: 10,
    marginBottom: 10
  },
  customWidth: {
    width: 150
  },
  block: {
    maxWidth: 250
  },
  radioButton: {
    width: 60
  },
  radioGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flex: "1 auto"
  },
  divText: {
    paddingBottom: 10
  }
};

ImageTextView.propTypes = {
  data: PropTypes.object,
  onUpdateData: PropTypes.func.isRequired
};

ImageTextView.defaultProps = {
  data: {}
};
export default ImageTextView;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/ImageTextView.js